<template>
  <form @submit.prevent="validateBeforeSubmit">
    
      <div
        class="card-header first-header card-expandable"
        id="headingOne"
        data-toggle="collapse"
        data-target="#collapseOne"
        aria-expanded="true"
        aria-controls="collapseOne"
      >
        <div class="title">
          <i class="feather-icon icon-file-plus"></i>
          <h5 class="mb-0">รายละเอียดการขอค้ำประกัน</h5>
        </div>
      </div>
      <div
        id="collapseOne"
        class="collapse show"
        aria-labelledby="headingOne"
        data-parent="#accordion"
      >
        <div class="card-body compact-padding">
          <div class="default-padding">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>ผู้รับผลประโยชน์(ผู้รับหนังสือค้ำประกัน)</label>
                <v-select
                  v-model="nonebcBeneficiary"
                  name="nonebcBeneficiary"
                  class="vue-select1"
                  ref="input"
                  @input="getLgTypeList().then(() => { return getFormNoList(); }).then(() => { return getCommitmentList(); });"
                  v-validate="'required'"
                  :disabled="this.appVo.beneGroup==='MEA' || this.appVo.beneGroup==='PEA'"
                  :class="{'input': true, 'is-danger': errors.has('nonebcBeneficiary') }"
                  :options="beneficiaryList"
                  :reduce="option => ({ beneTaxId: option.taxid, beneGroup: option.group, beneName: option.nameTH })"
                  label="nameTH"
                >
                </v-select>
                <span
                  v-show="errors.has('nonebcBeneficiary')"
                  class="help is-danger"
                >ระบุ ผู้รับผลประโยชน์</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>ประเภทค้ำประกัน</label> 
                <select
                  v-model="lgTypeObj"
                  name="lgTypeObj"
                  ref="refLgType"
                  class="form-control"
                  @change="getFormNoList().then(() => { return getCommitmentList(); });"
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('lgTypeObj') }"
                  :disabled="(this.appVo.contingentTypeId!=='9' && this.appVo.lgFormNo==='') || (this.appVo.beneGroup==='MEA' || this.appVo.beneGroup==='PEA')"
                >
                  <option
                    v-for="option in custLgTypeList"
                    v-bind:value="{ contingentId: option.contingentId, mtContingentId: option.mtContingentId, lgFormNo: option.lgFormNo, marketCd: option.marketCd}"
                  >{{ option.lgNameTh }}</option>
                </select>
                <span v-show="errors.has('lgTypeObj')" class="help is-danger">ระบุ ประเภทค้ำประกัน</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>รหัสแบบฟอร์มหนังสือค้ำประกัน</label>
                <select
                  v-model="lgFormNo"
                  name="lgFormNo"
                  class="form-control"
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('lgFormNo') }"
                >
                <option value="">กรุณาเลือก</option>
                  <option
                    v-for="option in lgFormList"
                    v-bind:value="option.lgFormNo"
                    :key="option.lgFormNo"
                  >{{ option.lgFormNo }}</option>
                </select>
                <span v-show="errors.has('lgFormNo')" class="help is-danger">ระบุ รหัสแบบฟอร์มหนังสือค้ำประกัน</span>
              </div>
            </div> 
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>หมายเลขบัญชีวงเงิน</label>
                <select
                  v-model="nonebcCommNo"
                  name="nonebcCommNo"
                  ref="nonebcCommNo"
                  class="form-control"
                  @change="getAccountByCommNo().then(() => {   return getGuaranteeList(); });"
                  
                  v-validate="{required:true}"
                  :class="{'input': true, 'is-danger': errors.has('nonebcCommNo') }"
                >
                  <option
                    v-for="option in commList"
                    v-bind:value="option.accountNo"
                  >{{ option.accountNo }}:{{option.accountName}}</option>
                </select>
                <span
                  v-show="errors.has('accountNo')"
                  class="help is-danger"
                >ระบุ หมายเลขบัญชีวงเงิน</span>
              </div>
            </div>

            <div class="option-form mb-4">
              <div class="form-group">
                <label>เพื่อค้ำประกันในนาม</label>

                <div class="input-group" v-for="(guarantee, index) in guaranteeList" :key="`divGuarantee_+${guarantee.guaranteeTaxId.guaranteeTaxId}`">
                  <button
                    type="button"
                    class="btn btn-secondary-custom btn-icon btn-minus"
                    @click="removeGuarantee(index)"
                  >
                    <i class="feather-icon icon-minus"></i>
                  </button>
                  <select
                    v-model="guarantee.guaranteeTaxId"
                    :name="'guarantee_'+[index]+'.guaranteeTaxId'"
                    class="form-control"
                    @change="onRequesterLChange($event,guarantee)"
                    v-validate="'required'"
                    :class="{'input': true, 'is-danger': errors.has('guarantee_' + index+'.guaranteeTaxId') }"
                  >
                    <option
                      v-for="requester in requesterList"
                      v-bind:value="requester"
                      v-bind:key="`${requester.guaranteeTaxId}-${requester.guaranteeName}`"
                    >{{ requester.guaranteeTaxId }}</option>
                  </select>

                  <input
                    v-model="guarantee.guaranteeName"
                    :name="'guarantee_'+[index]+'.guaranteeName'"
                    type="text"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('guarantee_' + index+'.guaranteeName') }"
                    @change="onRequesterEmit()"
                    v-validate="{required:true}"
                    placeholder="ชื่อภาษาไทย"
                  >

                  <input
                    v-model="guarantee.guaranteeNameEN"
                    :name="'guarantee_'+[index]+'.guaranteeNameEN'"
                    type="text"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('guarantee_' + index+'.guaranteeNameEN') }"
                    @change="onRequesterEmit()"
                    v-validate="{required:true}"
                    placeholder="ชื่อภาษาอังกฤษ"
                  >

                  <button
                    type="button"
                    class="btn btn-secondary-custom btn-icon btn-plus"
                    @click="addGuarantee()"
                  >
                    <i class="feather-icon icon-plus"></i>
                  </button>
                </div>
              </div>
            </div>

            <component 
                :reqType="reqType" 
                :appVo="appVo"
                :beneTaxId = "nonebcBeneficiary.beneTaxId"
                :beneGroup = "nonebcBeneficiary.beneGroup"
                :lgFormNo = "lgFormNo"
                :lgType = "lgTypeObj.contingentId"
                :is="dynamicBeneChild" 
                v-on:childExtToParent="onChildExtChange"
                v-bind:lgSpecificFields="lgSpecificFields"/>
          </div>

        </div>
      </div>
    
  </form>
</template>

<script>
import { apiClient } from "@/utils/apiClient";

export default {
  inject: ["$validator"],
  props: ["appVo","reqType", "lgSpecificFields"],
  data() {
    return {
        beneTaxId: "",
        beneficiaryList: [],
        custLgTypeList: [],
        foundMarketCd: false,
        commList:[],
        accNoFee:"",
        accBalFee:"",
        nonebcBeneficiary: {
            beneTaxId: "",
            beneGroup: "",
            beneName: ""
        },
        beneficiary: {
            beneTaxId: "",
            beneGroup: "",
            beneName: ""
        },
        nonebclgType: "",
        guaranteeList: [
            {
            guaranteeTaxId: {guaranteeTaxId:"",guaranteeName:"",guaranteeNameEN:""},
            guaranteeName: "",
            guaranteeNameEN: ""
            }
        ],
        requesterList: [
            {
            guaranteeTaxId: "",
            guaranteeName: "",
            guaranteeNameEN: ""
            }
        ],
        lgTypeObj: {
          contingentId: "", 
          mtContingentId: "", 
          lgFormNo: "",
          marketCd: ""
        },
        nonebcCommNo:"",

        ctrNo :"",
        ctrDate :"",
        ctrName :"",
        securityNo :"",
        caNo :"",
        meterNo :"",
        bpNo :"",
        jobPrice :"",
        middlePrice:"",
        beneficiaryRemark:"",
        contingentTypeId:"",
        mtContingentId:"",
        lgFormNo:"",
        lgTypeName:"",
        commNo:"",
        lgFormList: [],
        ctrDatePEA: '',
        percentage: '',
        projectName: '',
        manyCtrNo:"",
        guaranteePriceAmt:"",
        contractPeriod:"",
        projectId:"",
        seqNo:"",
        projectBudgetAmt:"",
        bidExpireDate:"",
        projectOwner:"",
        advancePaymentAmt:"",
        collectionPhase:"",
        productType:"",
        dealerCode:"",
        manyCtrName:"",
        lgDescription3:"",
        lgDescription2:"",
        lgDescription4:"",
        lgDescription5:"",
        lgDescription6:"",
    };
  },
  computed: {
    dynamicBeneChild() {
      const beneCode = this.nonebcBeneficiary.beneGroup;
      const lgType = this.lgTypeObj.contingentId;
      const lgForm = this.lgFormNo;
      // console.log('beneCode',beneCode)
      // console.log('lgType',lgType)
      // console.log('lgForm',lgForm)
      return () => import(`@/components/request/extend/DYNAMIC_SPECIFIC_FIELD`);
    }
  },
  methods: {
      getFormNoList: function(){
          return new Promise((resolve, reject) => {
            this.lgFormNo = '';
          if (
            this.lgTypeObj.contingentId !== undefined &&
            this.lgTypeObj.contingentId != "" &&
            this.lgTypeObj.contingentId !== null
          ) {
            this.loader = this.$loading.show();
            apiClient
              .get(
                "/api/home/getFormNo/" + this.nonebcBeneficiary.beneTaxId+"/"+this.lgTypeObj.contingentId
              )
              .then(resp => {
                this.loader.hide();
                this.lgFormList = resp.data;

                if (resp.data.length === 1) {
                  this.lgFormNo = resp.data[0].lgFormNo;
                }else if (resp.data.length > 0) {
                  this.lgFormNo="";
                }else{
                    this.lgFormNo="";
                    this.$swal("", "ไม่พบแบบฟอร์มสำหรับประเภทการค้ำประกันนี้", "error");
                }
                resolve();
              })
              .catch((error) => {
                if(error.response.status===401){
                  this.loader.hide();
                }
              });
          }
        });
      },
      onRequesterLChange(event, guarantee) {
      var taxId = this.requesterList[event.target.selectedIndex].guaranteeTaxId;
      let gName = this.requesterList[event.target.selectedIndex].guaranteeName;
      let gNameEN = this.requesterList[event.target.selectedIndex].guaranteeNameEN;

      var dup = false;
      for (var i = 0; i < this.guaranteeList.length - 1; i++) {
        if (taxId === this.guaranteeList[i].guaranteeTaxId.guaranteeTaxId) {
          dup = true;
          break;
        }
      }

      if (!dup) {
        guarantee.guaranteeName = gName;
        guarantee.guaranteeNameEN = gNameEN;
        this.onRequesterEmit();
      } else {
        guarantee.guaranteeTaxId = null;
        guarantee.guaranteeName = null;
        guarantee.guaranteeNameEN = null;
        this.$swal("", "เพื่อค้ำประกันในนามซ้ำกรุณาเลือกใหม่ ", "warning");
      }
    },
    onRequesterEmit: function(){

      let bcFlag = '';
      try {
        bcFlag = this.commList[this.$refs.nonebcCommNo.selectedIndex].accountBlockChain;
      } catch (error) { }

        this.$emit("childExtToParent", {
        ctrNo : this.ctrNo,
        ctrDate : this.ctrDate,
        ctrName : this.ctrName,
        securityNo : this.securityNo,
        caNo : this.caNo,
        meterNo : this.meterNo,
        bpNo : this.bpNo,
        jobPrice : this.jobPrice,
        middlePrice : this.middlePrice,
        bcFlagByComNo : bcFlag,
        commNo: this.nonebcCommNo,
        requesterList:this.convertGuaranteeList(),
        beneficiary: this.nonebcBeneficiary,
        accNoFee:this.accNoFee,
        accBalFee:this.accBalFee,
        beneficiaryRemark: this.beneficiaryRemark,
        contingentTypeId: this.lgTypeObj.contingentId,
        mtContingentId: this.lgTypeObj.mtContingentId,
        lgFormNo:this.lgFormNo,
        lgTypeName:this.getLGTypeName(this.lgTypeObj.mtContingentId),
        ctrDatePEA : this.ctrDatePEA,
        percentage: this.percentage,
        projectName: this.projectName,
        manyCtrNo : this.manyCtrNo,
        manyCtrDate : this.manyCtrDate,
        guaranteePriceAmt : this.guaranteePriceAmt,
        hospitalCode: this.hospitalCode,
        hospitalName: this.hospitalName,
        contractTypeId: this.contractTypeId,
        contractTypeDesc: this.contractTypeDesc,
        contractPeriod: this.contractPeriod,
        projectId: this.projectId,
        seqNo: this.seqNo,
        projectBudgetAmt: this.projectBudgetAmt,
        bidExpireDate: this.bidExpireDate,
        projectOwner: this.projectOwner,
        advancePaymentAmt: this.advancePaymentAmt,
        collectionPhase: this.collectionPhase,
        productType: this.productType,
        dealerCode: this.dealerCode,
        manyCtrName: this.manyCtrName,
        lgDescription3: this.lgDescription3,
        lgDescription2: this.lgDescription2,
        lgDescription4: this.lgDescription4,
        lgDescription5: this.lgDescription5,
        lgDescription6: this.lgDescription6
      });
    },
    getLgTypeList: function() {      
      return new Promise((resolve, reject) => {
        if( this.reqType == 3 && this.nonebcBeneficiary.beneTaxId === "0105533121519"){
          this.$swal("", "ไม่สามารถ เพิ่มวงเงิน หนังสือค้ำประกันจาก LG ทั่วไป(กระดาษ) มาเป็น LG Blockchain ได้", "error");
          return;
        }
        if( this.reqType == 4 && this.nonebcBeneficiary.beneTaxId === "0105533121519"){
          this.$swal("", "ไม่สามารถ ต่ออายุ+เพิ่มวงเงิน หนังสือค้ำประกันจาก LG ทั่วไป(กระดาษ) มาเป็น LG Blockchain ได้", "error");
          return;
        }
        this.foundMarketCd = false;
        if(this.nonebcBeneficiary.beneTaxId === ''){
          return false;
        }
        apiClient.get("/api/home/getBeneficiaryProfileNonForm/" + this.nonebcBeneficiary.beneTaxId)
          .then(resp => {
            this.custLgTypeList = resp.data;
            if (resp.data.length > 0) {
              if(this.appVo.contingentTypeId!=null && this.appVo.contingentTypeId!==''){
                for(var i = 0; i<this.custLgTypeList.length;i++){
                  if(this.appVo.contingentTypeId===resp.data[i].contingentId){
                    this.foundMarketCd = true;
                    this.lgTypeObj = {
                      contingentId :resp.data[i].contingentId,
                      mtContingentId: resp.data[i].mtContingentId, 
                      lgFormNo: resp.data[i].lgFormNo,
                      marketCd: resp.data[i].marketCd
                    };
                  }
                }
                if( this.foundMarketCd === false ){

                  this.lgTypeObj = {
                      contingentId :'',
                      mtContingentId: '', 
                      lgFormNo: '',
                      marketCd: ''
                  };

                  this.$swal("", "ไม่มีบัญชีวงเงินสำหรับประเภทการค้ำประกันนี้", "error");
                }

              }else{
                  this.lgTypeObj = {
                    contingentId :resp.data[0].contingentId,
                    mtContingentId: resp.data[0].mtContingentId, 
                    lgFormNo: resp.data[0].lgFormNo,
                    marketCd: resp.data[0].marketCd
                  };
              }
            }
            resolve();
          })
          .catch((error) => {
                if(error.response.status===401){
                  this.loader.hide();
                }
          }); 
      });
    },
    getLGTypeName(mtLgType) {
      const result = this.custLgTypeList.filter(member => {
        return member.mtContingentId == mtLgType;
      });

      return result[0] != null ? result[0].lgNameTh : "";
    },

    getCommitmentList: function() {
        return new Promise((resolve, reject) => {
            if (
              this.lgTypeObj.contingentId !== undefined &&
              this.lgTypeObj.contingentId != "" &&
              this.lgTypeObj.contingentId !== null
            /*this.nonebclgType !== undefined &&
            this.nonebclgType != "" &&
            this.nonebclgType !== null*/
            ) {
              this.loader = this.$loading.show();
              apiClient
                //.get("/api/elg/getCreditLimitAccountForMigration/" + this.appVo.marketCode)
                .get("/api/elg/getCreditLimitAccountForMigration/" + this.lgTypeObj.marketCd+"/"+this.nonebcBeneficiary.beneGroup)
                .then(resp => {
                
	              this.loader.hide();
                this.commList = resp.data;

                if (resp.data.length > 0) {
                    if(resp.data[0].accountBlockChain!=="1"){//แสดงว่ามีแต่วงเงินกระดาษ ให้ default วงเงินเดิม
                        var foundAccount = false;
                        for(var i = 0; i<this.commList.length;i++){
                          if(this.appVo.commNo === this.commList[i].accountNo){
                            foundAccount = true;
                            break;
                          }
                        }
                        if(foundAccount === true){
                          this.nonebcCommNo = this.appVo.commNo;
                          this.$refs.nonebcCommNo.disabled="true";//for defect UAT 159
                          this.getAccountByCommNo();
                        }else{
                          this.nonebcCommNo="";
                          this.$refs.nonebcCommNo.disabled="true";//for defect UAT 159
                          this.$swal("", "ไม่พบวงเงินสำหรับประเภทการค้ำประกันนี้", "error");
                        }
                    }else{
                        this.nonebcCommNo = resp.data[0].accountNo;
                    }
                }else{
                  this.nonebcCommNo="";
                  this.$swal("", "ไม่พบวงเงินสำหรับประเภทการค้ำประกันนี้", "error");
                }
                resolve();
                })
                .catch((error) => {
                  if(error.response.status===401){
                    this.loader.hide();
                  }
                });
            }
        });
    },
    getAccountByCommNo: function() {
      return new Promise((resolve, reject) => {
        // if (this.nonebcCommNo === null || this.nonebcCommNo === "" || this.nonebcCommNo === undefined) {
        //   if (this.commList !== null && this.commList.length > 0) {
        //     this.nonebcCommNo = this.commList[0].accountNo;
        //   }
        // }
       
        if (this.nonebcCommNo === null || this.nonebcCommNo === "" || this.nonebcCommNo === undefined) {
          return false;
        }

        //this.loader = this.$loading.show();
        apiClient.get("/api/elg/defaultCard/" + this.nonebcCommNo).then(resp => {
         // this.loader.hide();
         if (resp.data !== '' && resp.data.feeDebitAccountList !== null && resp.data.feeDebitAccountList.length > 0 && resp.data.feeDebitAccountList[0].accountNo !== "") {
          this.accNoFee = resp.data.feeDebitAccountList[0].accountNo;
          this.accBalFee = resp.data.feeDebitAccountList[0].availableBalance;
         }
          //this.requesterList = resp.data.requesterList;
          this.requesterList = [];
          this.requesterList.push({
            guaranteeTaxId: this.appVo.requesterTaxId,
            guaranteeName: this.appVo.requesterNameTh,
            guaranteeNameEN: this.appVo.requesterNameEn
          });

          this.guaranteeList[0].guaranteeTaxId = {
            guaranteeTaxId: this.appVo.requesterTaxId,
            guaranteeName: this.appVo.requesterNameTh,
            guaranteeNameEN: this.appVo.requesterNameEn
          };
          this.guaranteeList[0].guaranteeName = this.appVo.requesterNameTh;
          this.guaranteeList[0].guaranteeNameEN = this.appVo.requesterNameEn;

          resolve();
        })
        .catch((error) => {
                if(error.response.status===401){
                  this.loader.hide();
                }
        });
      });
    },


    initialTransferDataToParent: function(){

    return new Promise((resolve, reject) => {
        let bcFlag = '';
        try {
          bcFlag = this.commList[this.$refs.nonebcCommNo.selectedIndex].accountBlockChain;
        } catch (error) { }
      this.$emit("childExtToParent", {
          ctrNo : this.ctrNo,
          ctrDate : this.ctrDate,
          ctrName : this.ctrName,
          securityNo : this.securityNo,
          caNo : this.caNo,
          meterNo : this.meterNo,
          bpNo : this.bpNo,
          jobPrice : this.jobPrice,
          middlePrice : this.middlePrice,
          bcFlagByComNo : bcFlag,
          commNo: this.nonebcCommNo,
          requesterList:this.convertGuaranteeList(),
          beneficiary: this.nonebcBeneficiary,
          accNoFee:this.accNoFee,
          accBalFee:this.accBalFee,
          beneficiaryRemark:this.beneficiaryRemark,
          contingentTypeId:this.lgTypeObj.contingentId,
          mtContingentId:this.lgTypeObj.mtContingentId,
          lgFormNo:this.lgFormNo,
          lgTypeName:this.getLGTypeName(this.lgTypeObj.mtContingentId),
          ctrDatePEA : this.ctrDatePEA,
          percentage: this.percentage,
          projectName: this.projectName,
          manyCtrNo : this.manyCtrNo,
          manyCtrDate : this.manyCtrDate,
          guaranteePriceAmt : this.guaranteePriceAmt,
          hospitalCode: this.hospitalCode,
          hospitalName: this.hospitalName,
          contractTypeId: this.contractTypeId,
          contractTypeDesc: this.contractTypeDesc,
          contractPeriod : this.contractPeriod,
          projectId: this.projectId,
          seqNo: this.seqNo,
          projectBudgetAmt: this.projectBudgetAmt,
          bidExpireDate: this.bidExpireDate,
          projectOwner: this.projectOwner,
          advancePaymentAmt: this.advancePaymentAmt,
          collectionPhase: this.collectionPhase,
          productType: this.productType,
          dealerCode: this.dealerCode,
          manyCtrName: this.manyCtrName,
          lgDescription3: this.lgDescription3,
          lgDescription2: this.lgDescription2,
          lgDescription4: this.lgDescription4,
          lgDescription5: this.lgDescription5,
          lgDescription6: this.lgDescription6
      });
      resolve();
      });
  },

    addGuarantee() {
      this.guaranteeList.push({
        guaranteeTaxId: "",
        guaranteeName: "",
        guaranteeNameEN: ""
      });
    },

    removeGuarantee: function(index) {
      if (this.guaranteeList.length > 1) {
        this.guaranteeList.splice(index, 1);
      }
      this.onRequesterEmit();
    },

    getGuaranteeList: function() {
      for (var i = 1; i <= this.guaranteeList.length - 1; i++) {
        this.guaranteeList.splice(i);
      }
      this.loader.hide();
    },

    onChildExtChange(value) {
        this.ctrNo = value.ctrNo;
        this.ctrDate = value.ctrDate;
        this.ctrName = value.ctrName;
        this.securityNo = value.securityNo;
        this.caNo = value.caNo;
        this.meterNo = value.meterNo;
        this.bpNo = value.bpNo;
        this.jobPrice = value.jobPrice;
        this.middlePrice = value.middlePrice;
        this.beneficiaryRemark = value.beneficiaryRemark;
        this.projectName = value.projectName;
        this.percentage = value.percentage;
        this.ctrDatePEA = value.ctrDatePEA;
        this.manyCtrNo = value.manyCtrNo;
        this.manyCtrDate = value.manyCtrDate;
        this.guaranteePriceAmt = value.guaranteePriceAmt;
        this.hospitalCode = value.hospitalCode;
        this.hospitalName = value.hospitalName;
        this.contractTypeId = value.contractTypeId;
        this.contractTypeDesc = value.contractTypeDesc;
        this.contractPeriod = value.contractPeriod;
        this.projectId = value.projectId;
        this.seqNo = value.seqNo;
        this.projectBudgetAmt = value.projectBudgetAmt;
        this.bidExpireDate = value.bidExpireDate;
        this.projectOwner = value.projectOwner;
        this.advancePaymentAmt = value.advancePaymentAmt;
        this.collectionPhase = value.collectionPhase;
        this.productType = value.productType;
        this.dealerCode = value.dealerCode;
        this.manyCtrName = value.manyCtrName;
        this.lgDescription3 = value.lgDescription3;
        this.lgDescription2 = value.lgDescription2;
        this.lgDescription4 = value.lgDescription4;
        this.lgDescription5 = value.lgDescription5;
        this.lgDescription6 = value.lgDescription6;
        let bcFlag = '';
        try {
          bcFlag = this.commList[this.$refs.nonebcCommNo.selectedIndex].accountBlockChain;
        } catch (error) { }

        this.$emit("childExtToParent", {
            ctrNo : this.ctrNo,
            ctrDate : this.ctrDate,
            ctrName : this.ctrName,
            securityNo : this.securityNo,
            caNo : this.caNo,
            meterNo : this.meterNo,
            bpNo : this.bpNo,
            jobPrice : this.jobPrice,
            middlePrice : this.middlePrice,
            bcFlagByComNo : bcFlag,
            commNo: this.nonebcCommNo,
            requesterList:this.convertGuaranteeList(),
            beneficiary: this.nonebcBeneficiary,
            accNoFee:this.accNoFee,
            accBalFee:this.accBalFee,
            beneficiaryRemark: this.beneficiaryRemark,
            contingentTypeId: this.lgTypeObj.contingentId,
            mtContingentId: this.lgTypeObj.mtContingentId,
            lgFormNo:this.lgFormNo,
            lgTypeName:this.getLGTypeName(this.lgTypeObj.mtContingentId),
            foundMarketCd: this.foundMarketCd,
            ctrDatePEA : this.ctrDatePEA,
            percentage: this.percentage,
            projectName: this.projectName,
            manyCtrNo : this.manyCtrNo,
            manyCtrDate : this.manyCtrDate,
            guaranteePriceAmt : this.guaranteePriceAmt,
            hospitalCode: this.hospitalCode,
            hospitalName: this.hospitalName,
            contractTypeId: this.contractTypeId,
            contractTypeDesc: this.contractTypeDesc,
            contractPeriod : this.contractPeriod,
            projectId: this.projectId,
            seqNo: this.seqNo,
            projectBudgetAmt: this.projectBudgetAmt,
            bidExpireDate: this.bidExpireDate,
            projectOwner: this.projectOwner,
            advancePaymentAmt: this.advancePaymentAmt,
            collectionPhase: this.collectionPhase,
            productType: this.productType,
            dealerCode: this.dealerCode,
            manyCtrName: this.manyCtrName,
            lgDescription3: this.lgDescription3,
            lgDescription2: this.lgDescription2,
            lgDescription4: this.lgDescription4,
            lgDescription5: this.lgDescription5,
            lgDescription6: this.lgDescription6
        });
    },    

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    convertGuaranteeList() {
      var glist = new Array(this.guaranteeList.length);

      for(var i=0;i<this.guaranteeList.length;i++){
        glist[i] = {
          guaranteeTaxId: this.guaranteeList[i].guaranteeTaxId.guaranteeTaxId,
          guaranteeName: this.guaranteeList[i].guaranteeName,
          guaranteeNameEN: this.guaranteeList[i].guaranteeNameEN
        }
      }
      return glist;
    },
  },  

  mounted() {
        this.nonebcBeneficiary = '';
        apiClient.get("/api/elg/getBeneficiaryMigrateByMarketCode/"+this.appVo.marketCode).then(resp => {
            this.beneficiaryList = resp.data;
            for(var i = 0; i<this.beneficiaryList.length;i++){
              //defect UAT#12 bridgestone
                if((this.appVo.beneGroup===this.beneficiaryList[i].group)&&(this.appVo.beneGroup==="PEA" || this.appVo.beneGroup==="MEA")){
                     this.nonebcBeneficiary = {
                         beneTaxId: this.beneficiaryList[i].taxid,
                         beneGroup: this.beneficiaryList[i].group,
                         beneName: this.beneficiaryList[i].nameTH
                     }  
                }else{
                    // this.nonebcBeneficiary = {
                    //     beneTaxId: this.beneficiaryList[0].taxid,
                    //     beneGroup: this.beneficiaryList[0].group,
                    //     beneName: this.beneficiaryList[0].nameTH
                    // }     
                }
                
                this.beneficiary=this.nonebcBeneficiary;
                
                this.$emit("childExtToParent", {
                  commNo: this.nonebcCommNo,
                  requesterList:this.convertGuaranteeList(),
                  beneficiary: this.nonebcBeneficiary,
                  accNoFee:this.accNoFee,
                  accBalFee:this.accBalFee,
              });
                
            }

          this.getLgTypeList()
          .then(() => {return this.getFormNoList();})
          .then(() => {
            return this.getCommitmentList();
          })
          .then(() => {
            return this.getAccountByCommNo();
          })
          .then(() => {
            return this.initialTransferDataToParent();
          });
        })
        .catch((error) => {
          if(error.response.status===401){
            this.loader.hide();
          }
        });
  },

  watch: {

    nonebcBeneficiary(newVal, oldVal) {
      
      let bcFlag = '';
      try {
        bcFlag = this.commList[this.$refs.nonebcCommNo.selectedIndex].accountBlockChain;
      } catch (error) { }
      this.$emit("childExtToParent", {
        ctrNo : this.ctrNo,
        ctrDate : this.ctrDate,
        securityNo : this.securityNo,
        caNo : this.caNo,
        meterNo : this.meterNo,
        bpNo : this.bpNo,
        jobPrice : this.jobPrice,
        middlePrice : this.middlePrice,
        bcFlagByComNo : bcFlag,
        commNo: this.nonebcCommNo,
        requesterList:this.convertGuaranteeList(),
        beneficiary: this.nonebcBeneficiary,
        accNoFee:this.accNoFee,
        accBalFee:this.accBalFee,
        beneficiaryRemark: this.beneficiaryRemark,
        contingentTypeId: this.lgTypeObj.contingentId,
        mtContingentId: this.lgTypeObj.mtContingentId,
        lgFormNo:this.lgFormNo,
        lgTypeName:this.getLGTypeName(this.lgTypeObj.mtContingentId),
        ctrDatePEA : this.ctrDatePEA,
        percentage: this.percentage,
        projectName: this.projectName,
        manyCtrNo : this.manyCtrNo,
        manyCtrDate : this.manyCtrDate,
        guaranteePriceAmt : this.guaranteePriceAmt,
        hospitalCode: this.hospitalCode,
        hospitalName: this.hospitalName,
        contractTypeId: this.contractTypeId,
        contractTypeDesc: this.contractTypeDesc,
        contractPeriod : this.contractPeriod,
        projectId: this.projectId,
        seqNo: this.seqNo,
        projectBudgetAmt: this.projectBudgetAmt,
        bidExpireDate: this.bidExpireDate,
        projectOwner: this.projectOwner,
        advancePaymentAmt: this.advancePaymentAmt,
        collectionPhase: this.collectionPhase,
        productType: this.productType,
        dealerCode: this.dealerCode,
        manyCtrName: this.manyCtrName,
        lgDescription3: this.lgDescription3,
        lgDescription2: this.lgDescription2,
        lgDescription4: this.lgDescription4,
        lgDescription5: this.lgDescription5,
        lgDescription6: this.lgDescription6
      });
    },
    nonebcCommNo(newVal, oldVal) {
     
      let bcFlag = '';
      try {
        bcFlag = this.commList[this.$refs.nonebcCommNo.selectedIndex].accountBlockChain;
      } catch (error) { }
      
      this.$emit("childExtToParent", {
        ctrNo : this.ctrNo,
        ctrDate : this.ctrDate,
        securityNo : this.securityNo,
        caNo : this.caNo,
        meterNo : this.meterNo,
        bpNo : this.bpNo,
        jobPrice : this.jobPrice,
        middlePrice : this.middlePrice,
        bcFlagByComNo : bcFlag,
        commNo: this.nonebcCommNo,
        requesterList:this.convertGuaranteeList(),
        beneficiary: this.nonebcBeneficiary,
        accNoFee:this.accNoFee,
        accBalFee:this.accBalFee,
        beneficiaryRemark: this.beneficiaryRemark,
        contingentTypeId: this.lgTypeObj.contingentId,
        mtContingentId: this.lgTypeObj.mtContingentId,
        lgFormNo:this.lgFormNo,
        lgTypeName:this.getLGTypeName(this.lgTypeObj.mtContingentId),
        ctrDatePEA : this.ctrDatePEA,
        percentage: this.percentage,
        projectName: this.projectName,
        manyCtrNo : this.manyCtrNo,
        manyCtrDate : this.manyCtrDate,
        guaranteePriceAmt : this.guaranteePriceAmt,
        hospitalCode: this.hospitalCode,
        hospitalName: this.hospitalName,
        contractTypeId: this.contractTypeId,
        contractTypeDesc: this.contractTypeDesc,
        contractPeriod : this.contractPeriod,
        projectId: this.projectId,
        seqNo: this.seqNo,
        projectBudgetAmt: this.projectBudgetAmt,
        bidExpireDate: this.bidExpireDate,
        projectOwner: this.projectOwner,
        advancePaymentAmt: this.advancePaymentAmt,
        collectionPhase: this.collectionPhase,
        productType: this.productType,
        dealerCode: this.dealerCode,
        manyCtrName: this.manyCtrName,
        lgDescription3: this.lgDescription3,
        lgDescription2: this.lgDescription2,
        lgDescription4: this.lgDescription4,
        lgDescription5: this.lgDescription5,
        lgDescription6: this.lgDescription6
      });
    },

    lgTypeObj(){
      
      let bcFlag = '';
      try {
        bcFlag = this.commList[this.$refs.nonebcCommNo.selectedIndex].accountBlockChain;
      } catch (error) { }

      this.$emit("childExtToParent", {
        ctrNo : this.ctrNo,
        ctrDate : this.ctrDate,
        securityNo : this.securityNo,
        caNo : this.caNo,
        meterNo : this.meterNo,
        bpNo : this.bpNo,
        jobPrice : this.jobPrice,
        middlePrice : this.middlePrice,
        bcFlagByComNo : bcFlag,
        commNo: this.nonebcCommNo,
        requesterList:this.convertGuaranteeList(),
        beneficiary: this.nonebcBeneficiary,
        accNoFee:this.accNoFee,
        accBalFee:this.accBalFee,
        beneficiaryRemark: this.beneficiaryRemark,
        contingentTypeId: this.lgTypeObj.contingentId,
        mtContingentId: this.lgTypeObj.mtContingentId,
        lgFormNo:this.lgFormNo,
        lgTypeName:this.getLGTypeName(this.lgTypeObj.mtContingentId),
        ctrDatePEA : this.ctrDatePEA,
        percentage: this.percentage,
        projectName: this.projectName,
        manyCtrNo : this.manyCtrNo,
        manyCtrDate : this.manyCtrDate,
        guaranteePriceAmt : this.guaranteePriceAmt,
        hospitalCode: this.hospitalCode,
        hospitalName: this.hospitalName,
        contractTypeId: this.contractTypeId,
        contractTypeDesc: this.contractTypeDesc,
        contractPeriod : this.contractPeriod,
        projectId: this.projectId,
        seqNo: this.seqNo,
        projectBudgetAmt: this.projectBudgetAmt,
        bidExpireDate: this.bidExpireDate,
        projectOwner: this.projectOwner,
        advancePaymentAmt: this.advancePaymentAmt,
        collectionPhase: this.collectionPhase,
        productType: this.productType,
        dealerCode: this.dealerCode,
        manyCtrName: this.manyCtrName,
        lgDescription3: this.lgDescription3,
        lgDescription2: this.lgDescription2,
        lgDescription4: this.lgDescription4,
        lgDescription5: this.lgDescription5,
        lgDescription6: this.lgDescription6
      });
    },

    requesterList(){
      
      let bcFlag = '';
      try {
        bcFlag = this.commList[this.$refs.nonebcCommNo.selectedIndex].accountBlockChain;
      } catch (error) { }

      this.$emit("childExtToParent", {
        ctrNo : this.ctrNo,
        ctrDate : this.ctrDate,
        securityNo : this.securityNo,
        caNo : this.caNo,
        meterNo : this.meterNo,
        bpNo : this.bpNo,
        jobPrice : this.jobPrice,
        middlePrice : this.middlePrice,
        bcFlagByComNo : bcFlag,
        commNo: this.nonebcCommNo,
        requesterList:this.convertGuaranteeList(),
        beneficiary: this.nonebcBeneficiary,
        accNoFee:this.accNoFee,
        accBalFee:this.accBalFee,
        beneficiaryRemark: this.beneficiaryRemark,
        contingentTypeId: this.lgTypeObj.contingentId,
        mtContingentId: this.lgTypeObj.mtContingentId,
        lgFormNo:this.lgFormNo,
        lgTypeName:this.getLGTypeName(this.lgTypeObj.mtContingentId),
        ctrDatePEA : this.ctrDatePEA,
        percentage: this.percentage,
        projectName: this.projectName,
        manyCtrNo : this.manyCtrNo,
        manyCtrDate : this.manyCtrDate,
        guaranteePriceAmt : this.guaranteePriceAmt,
        hospitalCode: this.hospitalCode,
        hospitalName: this.hospitalName,
        contractTypeId: this.contractTypeId,
        contractTypeDesc: this.contractTypeDesc,
        contractPeriod : this.contractPeriod,
        projectId: this.projectId,
        seqNo: this.seqNo,
        projectBudgetAmt: this.projectBudgetAmt,
        bidExpireDate: this.bidExpireDate,
        projectOwner: this.projectOwner,
        advancePaymentAmt: this.advancePaymentAmt,
        collectionPhase: this.collectionPhase,
        productType: this.productType,
        dealerCode: this.dealerCode,
        manyCtrName: this.manyCtrName,
        lgDescription3: this.lgDescription3,
        lgDescription2: this.lgDescription2,
        lgDescription4: this.lgDescription4,
        lgDescription5: this.lgDescription5,
        lgDescription6: this.lgDescription6
      });
    },

    lgFormNo(){
      let bcFlag = '';
      try {
        bcFlag = this.commList[this.$refs.nonebcCommNo.selectedIndex].accountBlockChain;
      } catch (error) { }

      this.$emit("childExtToParent", {
        ctrNo : this.ctrNo,
        ctrDate : this.ctrDate,
        securityNo : this.securityNo,
        caNo : this.caNo,
        meterNo : this.meterNo,
        bpNo : this.bpNo,
        jobPrice : this.jobPrice,
        middlePrice : this.middlePrice,
        bcFlagByComNo : bcFlag,
        commNo: this.nonebcCommNo,
        requesterList:this.convertGuaranteeList(),
        beneficiary: this.nonebcBeneficiary,
        accNoFee:this.accNoFee,
        accBalFee:this.accBalFee,
        beneficiaryRemark: this.beneficiaryRemark,
        contingentTypeId: this.lgTypeObj.contingentId,
        mtContingentId: this.lgTypeObj.mtContingentId,
        lgFormNo:this.lgFormNo,
        lgTypeName:this.getLGTypeName(this.lgTypeObj.mtContingentId),
        ctrDatePEA : this.ctrDatePEA,
        percentage: this.percentage,
        projectName: this.projectName,
        manyCtrNo : this.manyCtrNo,
        manyCtrDate : this.manyCtrDate,
        guaranteePriceAmt : this.guaranteePriceAmt,
        contractPeriod : this.contractPeriod,
        projectId: this.projectId,
        seqNo: this.seqNo,
        projectBudgetAmt: this.projectBudgetAmt,
        bidExpireDate: this.bidExpireDate,
        projectOwner: this.projectOwner,
        advancePaymentAmt: this.advancePaymentAmt,
        collectionPhase: this.collectionPhase,
        productType: this.productType,
        dealerCode: this.dealerCode,
        manyCtrName: this.manyCtrName,
        lgDescription3: this.lgDescription3,
        lgDescription2: this.lgDescription2,
        lgDescription4: this.lgDescription4,
        lgDescription5: this.lgDescription5,
        lgDescription6: this.lgDescription6
      });
    }

  },
  
};


</script>